var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudOffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.818,
    height: 156.555,
    viewBox: "0 0 192.818 156.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M198.82,204.845a6,6,0,0,1-4.259-1.766L49.947,58.465a6.026,6.026,0,0,1,8.519-8.519L203.079,194.56a6.026,6.026,0,0,1-4.259,10.285Z",
    transform: "translate(-30.104 -48.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.582,177.848C5.043,186.547,0,198.425,0,212.2A46.477,46.477,0,0,0,15.248,247.07c9.471,8.6,22.246,13.335,35.969,13.335h72.608a3.013,3.013,0,0,0,2.132-5.144L37.991,167.3a3.013,3.013,0,0,0-3.013-.753A53.3,53.3,0,0,0,14.582,177.848Z",
    transform: "translate(0 -121.927)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M284.15,187.233c8.726-6.948,13.335-17.263,13.335-29.838,0-21.681-15.817-34.112-32.975-37.942a6.026,6.026,0,0,1-4.564-4.666c-2.892-13.814-9.208-25.665-18.521-34.647A57.834,57.834,0,0,0,201.076,64a55.1,55.1,0,0,0-31.868,9.829,3.013,3.013,0,0,0-.429,4.617L278.535,188.2a3.013,3.013,0,0,0,3.841.35Q283.291,187.918,284.15,187.233Z",
    transform: "translate(-104.667 -58.083)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOffline);
export default __webpack_public_path__ + "static/media/cloud-offline.5389a71594521a6d2394b8976460032d.svg";
export { ForwardRef as ReactComponent };